import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { isArray } from 'lodash';
import { Tag } from '../../interfaces/Tag/Tag';
import { getTags } from '../../api/Tag';

interface TagsDropdownProps {
  label?: string;
  tagIDs: number[];
  onChange: (ids: number[]) => void;
}

export const TagsDropdown = (props: TagsDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState<Tag[]>([]);

  useEffect(() => {
    setLoading(true);
    getTags()
      .then((t) => setTags(t))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          multiple
          label={props.label}
          value={props.tagIDs}
          onChange={(e) =>
            props.onChange(isArray(e.target.value) ? e.target.value : [])
          }
        >
          {tags.map((tag) => (
            <MenuItem key={tag.id} value={tag.id}>
              {tag.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
